module.exports = __webpack_public_path__ + "statics/img/no-more.fa3e1e79.svg";